export const assets = {
  ar: () => import("./assets/locale/ar/translation.json"),
  en: () => import("./assets/locale/en/translation.json"),
  "es-419": () => import("./assets/locale/es-419/translation.json"),
  id: () => import("./assets/locale/id/translation.json"),
  mn: () => import("./assets/locale/mn/translation.json"),
  "pt-BR": () => import("./assets/locale/pt-BR/translation.json"),
  th: () => import("./assets/locale/th/translation.json"),
  vi: () => import("./assets/locale/vi/translation.json"),
  zh: () => import("./assets/locale/zh/translation.json"),
  "zh-TW": () => import("./assets/locale/zh-TW/translation.json"),
} as const;
